import { Schema as Schema_ } from '@blade/std-lib'

export const RegionKeySchema = Schema_.Union([
  Schema_.Literal('ny'),
  Schema_.Literal('de'),
  Schema_.Literal('ams'),
  Schema_.Literal('jp'),
  Schema_.Literal('la'),
])

export type RegionKey = Schema_.Schema.Type<typeof RegionKeySchema>

type LocationDef = {
  id: RegionKey
  label: string
}

export const NeyYork = {
  id: 'ny',
  label: 'New York',
} satisfies LocationDef

export const Frankfurt = {
  id: 'de',
  label: 'Frankfurt',
} satisfies LocationDef

export const Amsterdam = {
  id: 'ams',
  label: 'Amsterdam',
} satisfies LocationDef

export const Tokyo = {
  id: 'jp',
  label: 'Tokyo',
} satisfies LocationDef

export const LosAngeles = {
  id: 'la',
  label: 'Los Angeles',
} satisfies LocationDef

export type Region =
  | typeof NeyYork
  | typeof Frankfurt
  | typeof Amsterdam
  | typeof Tokyo
  | typeof LosAngeles

export const regions: ReadonlyArray<Region> = [
  NeyYork,
  Frankfurt,
  Amsterdam,
  Tokyo,
  LosAngeles,
]
